import React from 'react';
import DocumentTitle from 'react-document-title';
var selfStyles = require('./PageBasic.scss');
var PageBasic = function (props) {
    var appName = process.env.NODE_ENV === 'development'
        ? 'CRIMP.dev'
        : process.env.REACT_APP_DEPLOY_ENV === 'staging'
            ? 'PINCH'
            : 'CRIMP';
    var documentTitle = appName + " | Event management and scorekeeping for climbing events";
    if (props.documentTitle) {
        documentTitle = props.documentTitle + " | " + appName;
    }
    return (React.createElement(DocumentTitle, { title: documentTitle },
        React.createElement("div", { className: selfStyles.wrapper }, props.children)));
};
export default PageBasic;



//////////////////
// WEBPACK FOOTER
// ./src/pages/templates/PageBasic.tsx
// module id = 338
// module chunks = 0